import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Auth Context
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Pages
import Dashboard from './pages/Dashboard';
import CustomerDetails from './pages/CustomerDetails';
import Admin from './pages/Admin';

// Components
import BackupManager from './components/BackupManager';
import Login from './components/Login';

// Loading component
const LoadingScreen = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Yükleniyor...</p>
    </div>
  </div>
);

// Main App with Auth Check
const AppContent = () => {
  const { isAuthenticated, loading, user, logout } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              borderRadius: '12px',
              fontSize: '14px',
            },
          }}
        />
        
        {/* User Info & Logout */}
        <div className="bg-white shadow-sm border-b px-4 py-2 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <h1 className="text-lg font-semibold text-gray-900">🏢 Emanet Takip</h1>
            <span className="text-sm text-gray-500">•</span>
            <span className="text-sm text-gray-600">
              Hoşgeldin, <strong>{user?.name || user?.username}</strong>
            </span>
          </div>
          
          <button 
            onClick={logout}
            className="flex items-center gap-2 px-3 py-1.5 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            🚪 Çıkış Yap
          </button>
        </div>
        
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/customer/:id" element={<CustomerDetails />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/backup" element={<BackupManager />} />
          <Route path="*" element={
            <div className="flex items-center justify-center min-h-screen">
              <div className="text-center">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Sayfa Bulunamadı</h1>
                <p className="text-gray-600">Aradığınız sayfa mevcut değil.</p>
              </div>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App; 